import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

// Données des groupes World Cup 2026
const WORLD_CUP_GROUPS = {
  A: {
    name: 'Groupe A',
    teams: [
      { name: 'Mexique', code: 'MEX', flag: '🇲🇽' },
      { name: 'Corée du Sud', code: 'COR', flag: '🇰🇷' },
      { name: 'Afrique du Sud', code: 'AFS', flag: '🇿🇦' },
      { name: 'Barrage Europe D (Danemark, Macédoine du Nord, Rép. tchèque ou Irlande)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  B: {
    name: 'Groupe B',
    teams: [
      { name: 'Canada', code: 'CAN', flag: '🇨🇦' },
      { name: 'Suisse', code: 'SUI', flag: '🇨🇭' },
      { name: 'Qatar', code: 'QAT', flag: '🇶🇦' },
      { name: 'Barrage Europe A (Italie, Irlande du Nord, Pays de Galles ou Bosnie)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  C: {
    name: 'Groupe C',
    teams: [
      { name: 'Brésil', code: 'BRE', flag: '🇧🇷' },
      { name: 'Maroc', code: 'MAR', flag: '🇲🇦' },
      { name: 'Écosse', code: 'ÉCO', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' },
      { name: 'Haïti', code: 'HAÏ', flag: '🇭🇹' },
    ]
  },
  D: {
    name: 'Groupe D',
    teams: [
      { name: 'États-Unis', code: 'USA', flag: '🇺🇸' },
      { name: 'Australie', code: 'AUS', flag: '🇦🇺' },
      { name: 'Paraguay', code: 'PAR', flag: '🇵🇾' },
      { name: 'Barrage Europe C (Turquie, Roumanie, Slovaquie ou Kosovo)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  E: {
    name: 'Groupe E',
    teams: [
      { name: 'Allemagne', code: 'ALL', flag: '🇩🇪' },
      { name: 'Équateur', code: 'ECU', flag: '🇪🇨' },
      { name: 'Côte d\'Ivoire', code: 'CIV', flag: '🇨🇮' },
      { name: 'Curaçao', code: 'CUR', flag: '🇨🇼' },
    ]
  },
  F: {
    name: 'Groupe F',
    teams: [
      { name: 'Pays-Bas', code: 'P-B', flag: '🇳🇱' },
      { name: 'Japon', code: 'JAP', flag: '🇯🇵' },
      { name: 'Tunisie', code: 'TUN', flag: '🇹🇳' },
      { name: 'Barrage Europe B (Ukraine, Suède, Pologne ou Albanie)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  G: {
    name: 'Groupe G',
    teams: [
      { name: 'Belgique', code: 'BEL', flag: '🇧🇪' },
      { name: 'Iran', code: 'IRA', flag: '🇮🇷' },
      { name: 'Égypte', code: 'EGY', flag: '🇪🇬' },
      { name: 'Nouvelle-Zélande', code: 'NZL', flag: '🇳🇿' },
    ]
  },
  H: {
    name: 'Groupe H',
    teams: [
      { name: 'Espagne', code: 'ESP', flag: '🇪🇸' },
      { name: 'Uruguay', code: 'URU', flag: '🇺🇾' },
      { name: 'Arabie Saoudite', code: 'SAU', flag: '🇸🇦' },
      { name: 'Cap-Vert', code: 'CPV', flag: '🇨🇻' },
    ]
  },
  I: {
    name: 'Groupe I',
    teams: [
      { name: 'France', code: 'FRA', flag: '🇫🇷' },
      { name: 'Sénégal', code: 'SÉN', flag: '🇸🇳' },
      { name: 'Norvège', code: 'NOR', flag: '🇳🇴' },
      { name: 'Barrage Intercontinental 2 (Bolivie, Irak ou Suriname)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  J: {
    name: 'Groupe J',
    teams: [
      { name: 'Argentine', code: 'ARG', flag: '🇦🇷' },
      { name: 'Autriche', code: 'AUT', flag: '🇦🇹' },
      { name: 'Algérie', code: 'ALG', flag: '🇩🇿' },
      { name: 'Jordanie', code: 'JOR', flag: '🇯🇴' },
    ]
  },
  K: {
    name: 'Groupe K',
    teams: [
      { name: 'Portugal', code: 'POR', flag: '🇵🇹' },
      { name: 'Colombie', code: 'COL', flag: '🇨🇴' },
      { name: 'Ouzbékistan', code: 'OUZ', flag: '🇺🇿' },
      { name: 'Barrage Intercontinental 1 (N.-Calédonie, Jamaïque ou RD Congo)', code: '---', flag: '🏳️', tbd: true },
    ]
  },
  L: {
    name: 'Groupe L',
    teams: [
      { name: 'Angleterre', code: 'ANG', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
      { name: 'Croatie', code: 'CRO', flag: '🇭🇷' },
      { name: 'Panama', code: 'PAN', flag: '🇵🇦' },
      { name: 'Ghana', code: 'GHA', flag: '🇬🇭' },
    ]
  },
};

// Composant pour une équipe
const TeamRow = ({ team, position, onClick }) => (
  <div 
    className={`flex items-center gap-3 p-2.5 rounded-lg transition-all cursor-pointer hover:bg-white/10 ${team.tbd ? 'opacity-70' : ''}`}
    onClick={() => !team.tbd && onClick?.(team)}
  >
    <span className="text-xs text-zinc-500 w-4">{position}</span>
    <span className="text-2xl">{team.flag}</span>
    <span className={`font-medium text-sm flex-1 ${team.tbd ? 'text-zinc-400 italic' : 'text-white'}`}>
      {team.name}
    </span>
  </div>
);

// Composant pour un groupe
const GroupCard = ({ groupKey, group, onTeamClick }) => (
  <Card className="bg-gradient-to-br from-blue-900/50 to-blue-950/80 border-blue-500/30 hover:border-blue-400/50 transition-all">
    <CardHeader className="pb-2">
      <CardTitle className="text-center">
        <Badge className="bg-blue-500 text-white font-bold px-4 py-1 text-sm">
          GROUPE {groupKey}
        </Badge>
      </CardTitle>
    </CardHeader>
    <CardContent className="pt-0">
      <div className="space-y-1">
        {group.teams.map((team, idx) => (
          <TeamRow 
            key={idx} 
            team={team}
            position={idx + 1}
            onClick={onTeamClick}
          />
        ))}
      </div>
    </CardContent>
  </Card>
);

// Composant principal
export function WorldCupGroupsView({ onTeamClick }) {
  const [selectedGroup, setSelectedGroup] = useState(null);

  const handleTeamClick = (team) => {
    if (onTeamClick) {
      onTeamClick(team);
    }
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white flex items-center gap-3">
            <span className="text-3xl">⚽</span>
            FIFA World Cup 2026 - Groupes
          </h2>
          <p className="text-zinc-400 mt-1">
            12 groupes • 48 équipes • USA, Canada, Mexique
          </p>
        </div>
        <div className="flex gap-2">
          <Badge variant="outline" className="border-emerald-500 text-emerald-400">
            48 équipes qualifiées
          </Badge>
          <Badge variant="outline" className="border-amber-500 text-amber-400">
            6 barrages en cours
          </Badge>
        </div>
      </div>

      {/* Grille des groupes - 4 colonnes */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {Object.entries(WORLD_CUP_GROUPS).map(([key, group]) => (
          <GroupCard 
            key={key} 
            groupKey={key} 
            group={group}
            onTeamClick={handleTeamClick}
          />
        ))}
      </div>

      {/* Légende */}
      <div className="mt-6 flex items-center gap-6 text-sm text-zinc-400">
        <div className="flex items-center gap-2">
          <span className="text-lg">🏳️</span>
          <span>Équipe en attente (barrage)</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-blue-500"></span>
          <span>Cliquer sur une équipe pour filtrer les tickets</span>
        </div>
      </div>
    </div>
  );
}

export default WorldCupGroupsView;
